import {
  COMPANY_SWITCHER_WIDTH,
  DRAWER_WIDTH,
  SIDEBAR_DEFAULT_PX,
} from 'src/constants/uiConsts';
import { useFeatureFlags } from 'src/context';
import { useCompanySwitcherVisibility } from 'src/features/companies/useCompanySwitcherVisibility';

import { useSettingsSidebarWidth } from './useSettingsSidebarWidth';

// null = legacy drawer mode (returns DRAWER_WIDTH constant)
// number = panel mode: pixels from v4 onResize (0 when collapsed)
export const useDrawerWidth = (
  panelSizePixels: number | null = null,
): number => {
  const { EnableNewSidebar } = useFeatureFlags();
  const settingsSidebarWidth = useSettingsSidebarWidth();
  const drawerWidth =
    settingsSidebarWidth ??
    (EnableNewSidebar ? SIDEBAR_DEFAULT_PX : DRAWER_WIDTH);
  const isSidebarCompanySwitcherVisible = useCompanySwitcherVisibility();

  if (panelSizePixels !== null) {
    return Math.round(panelSizePixels);
  }

  return isSidebarCompanySwitcherVisible.visibility === 'desktop'
    ? drawerWidth + COMPANY_SWITCHER_WIDTH
    : drawerWidth;
};
